import gql from 'graphql-tag';
import { apollo } from 'src/features';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation ActivityCreateByCase($caseId: Int!, $channelIdentifier: String!) {
  activityByCase(caseId: $caseId, channelIdentifier: $channelIdentifier){
    id
  }
}`;

function createActivityByCase(caseId, channelIdentifier) {
  return apollo.client.mutate({
    mutation,
    variables: {
      caseId: parseInt(caseId, 10),
      channelIdentifier,
    },
  }).then((res) => (res.data.activityByCase.id))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default createActivityByCase;
